<template>
   <p>
      Your last step is to configure set up a variable. A variable is the basic
      building block of a user experience. It is the thing you want to change,
      test, and improve upon. To create your first variable, follow these steps:
   </p>
   <ol class="q-ml-md">
      <li>Visit your website</li>
      <li>
         Open the ezbot Visual Editor Chrome Extension via the ezbot icon in
         your browser toolbar
      </li>
      <li>
         Click on an element, you'd like to make into a variable. If you're not
         sure what to choose, try a button or heading.
      </li>
      <li>
         In the Element Editor section, select a change you'd like to make to
         the element, such as to text, font size, or background color.
      </li>
      <li>
         Create at least two variations of the element and save the variable.
      </li>
   </ol>
   <p>
      <strong
         >This step will automatically complete when you've created a
         variable.</strong
      >
   </p>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from "vue"
import { useProjectStore } from "@/stores/projectStore"
const projectStore = useProjectStore()
const checkVariablesIntervalId = ref<ReturnType<typeof setInterval> | null>(null)

onMounted(() => {
   checkVariablesIntervalId.value = setInterval(() => {
      projectStore.getVariablesByProjectId()
   }, 5000)
})
onUnmounted(() => {
   if (checkVariablesIntervalId.value) {
      clearInterval(checkVariablesIntervalId.value)
   }
})
</script>
